import clsx from 'clsx'
import { formatMoney, withCurrencyCode } from '../../../helpers/currency-formatter'

interface PriceProps {
  price: string
  compareAtPrice?: string
  className?: string
}

export function Price({ price, compareAtPrice, className }: PriceProps) {
  const isOnSale = parseFloat(price) < parseFloat(compareAtPrice || '0')

  const moneyFormat = window.globals?.shopify?.moneyFormat || '${{amount}}'
  const currencySymbol = window.globals?.shopify?.currencySymbol
  const currencyCode = window.globals?.shopify?.currency
  const defaultCurrencyCode = window.globals?.shopify?.defaultCurrency

  const formatPrice = (value: string) => {
    if (!value) return ''

    const priceInCents = Math.round(parseFloat(value) * 100)

    return withCurrencyCode(
      formatMoney(priceInCents, moneyFormat),
      currencySymbol,
      currencyCode,
      defaultCurrencyCode
    )
  }

  return (
    <p className={clsx(className)}>
      {!isOnSale ? null : (
        <span className="paragraph-xs text-type-black-secondary line-through">
          {formatPrice(compareAtPrice || '')}
        </span>
      )}

      <span className="paragraph-xs">
        {formatPrice(price)}
      </span>
    </p>
  )
}
